/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/

import fetch from "../../../api-client";
import type { RequestConfig, ResponseErrorConfig } from "../../../api-client";
import type { UploadsControllerCompleteUploadSessionMutationRequest, UploadsControllerCompleteUploadSessionMutationResponse, UploadsControllerCompleteUploadSessionPathParams } from "../../models/uploadsController/UploadsControllerCompleteUploadSession";

function getUploadsControllerCompleteUploadSessionUrl(id: UploadsControllerCompleteUploadSessionPathParams["id"]) {
  const res = { method: 'PATCH', url: `/api/v1/uploads/${id}` as const }  
  return res
}

/**
 * @summary Complete upload session
 * {@link /api/v1/uploads/:id}
 */
export async function uploadsControllerCompleteUploadSession(id: UploadsControllerCompleteUploadSessionPathParams["id"], data?: UploadsControllerCompleteUploadSessionMutationRequest, config: Partial<RequestConfig<UploadsControllerCompleteUploadSessionMutationRequest>> & { client?: typeof fetch } = {}) {
  const { client: request = fetch, ...requestConfig } = config  
  
  const requestData = data  
  
  const res = await request<UploadsControllerCompleteUploadSessionMutationResponse, ResponseErrorConfig<Error>, UploadsControllerCompleteUploadSessionMutationRequest>({ method : "PATCH", url : getUploadsControllerCompleteUploadSessionUrl(id).url.toString(), data : requestData, ... requestConfig, headers : { 'Content-Type': 'application/vnd.api+json', ...requestConfig.headers } })  
  return res.data
}